/*
  Cabora Goods — global.js
  Header interactions, mobile nav, scroll-reveal, and small shared helpers.
  Vanilla JS, no dependencies. Loaded with `defer`.
*/
(function () {
  'use strict';

  /* ---------- Money formatting (shared) ---------- */
  window.Cabora = window.Cabora || {};
  window.Cabora.formatMoney = function (cents) {
    var format = (window.CaboraCartConfig && window.CaboraCartConfig.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, value)
                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  /* ---------- Mobile navigation ---------- */
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var navToggle = document.querySelector('[data-nav-toggle]');
  function setNav(open) {
    if (!mobileNav) return;
    mobileNav.classList.toggle('is-open', open);
    mobileNav.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('nav-locked', open);
    if (navToggle) navToggle.setAttribute('aria-expanded', String(open));
  }
  if (mobileNav) {
    document.querySelectorAll('[data-nav-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setNav(!mobileNav.classList.contains('is-open'));
      });
    });
    document.querySelectorAll('[data-nav-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { setNav(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        setNav(false);
        if (navToggle) navToggle.focus();
      }
    });
  }

  /* ---------- Search toggle ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      // Toggle the `hidden` attribute (the [hidden] reset keeps a class-only
      // toggle invisible), and mirror an is-open class for styling.
      var open = searchPanel.hidden;
      searchPanel.hidden = !open;
      searchPanel.classList.toggle('is-open', open);
      searchToggle.setAttribute('aria-expanded', String(open));
      if (open) {
        var input = searchPanel.querySelector('input[type="search"], input[type="text"]');
        if (input) { setTimeout(function () { input.focus(); }, 50); }
      }
    });
    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !searchPanel.hidden) {
        searchPanel.hidden = true;
        searchPanel.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.focus();
      }
    });
  }

  /* ---------- Announcement bar dismiss (persists via localStorage) ---------- */
  var announce = document.querySelector('[data-announcement]');
  if (announce) {
    var key = 'cabora_announce_dismissed_' + (announce.dataset.announcementId || '1');
    try {
      if (localStorage.getItem(key) === '1') { announce.hidden = true; }
    } catch (e) {}
    var dismiss = announce.querySelector('[data-announcement-dismiss]');
    if (dismiss) {
      dismiss.addEventListener('click', function () {
        announce.hidden = true;
        try { localStorage.setItem(key, '1'); } catch (e) {}
      });
    }
  }

  /* ---------- Scroll reveal (IntersectionObserver) ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Accordions (FAQ / product) ---------- */
  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    acc.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        if (panel) { panel.hidden = expanded; }
      });
    });
  });

  /* ---------- Countdown timers (launch urgency) ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.countdown).getTime();
    if (isNaN(end)) { return; }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { el.textContent = el.dataset.countdownEnded || 'Offer ended'; return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = (d > 0 ? d + 'd ' : '') + h + 'h ' + m + 'm ' + s + 's';
      requestAnimationFrame(function () { setTimeout(tick, 1000); });
    }
    tick();
  });

})();
